import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filtro',
    standalone: false
})

export class FiltroPipe implements PipeTransform {

  transform(value: Array<{}>, page: number = 0): any {
    if (value) {
      return value.slice(page, page + 1);
    }
  }
}
